<script lang="ts">
  // A stepper. It sends nothing and changes nothing outside this screen — the whole
  // reason it can sit in a catalogue without any of the caution the sending controls
  // need.

  import { t } from '$lib/i18n/index.svelte';

  import type { CardState } from './card-state.svelte';

  let {
    itemId,
    card,
    disabled,
  }: { itemId: string; card: CardState; disabled: boolean } = $props();

  const value = $derived(card.get(itemId));
</script>

<span class="stepper" role="group" aria-label={t('views.control.quantity')}>
  <button
    type="button"
    {disabled}
    aria-label="−"
    onclick={() => card.set(itemId, value - 1)}>−</button
  >
  <input
    type="number"
    inputmode="numeric"
    min="0"
    max="999"
    {disabled}
    aria-label={t('views.control.quantity')}
    value={value}
    oninput={(e) => card.set(itemId, Number(e.currentTarget.value))}
  />
  <button
    type="button"
    {disabled}
    aria-label="+"
    onclick={() => card.set(itemId, value + 1)}>+</button
  >
</span>

<style>
  .stepper {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    border: 1px solid var(--line);
    border-radius: 8px;
    overflow: hidden;
  }
  button {
    border: 0;
    background: transparent;
    color: var(--ink);
    font: inherit;
    font-size: 16px;
    line-height: 1;
    padding: 6px 10px;
    cursor: pointer;
  }
  button:disabled {
    opacity: 0.4;
    cursor: default;
  }
  input {
    width: 3.2em;
    border: 0;
    border-left: 1px solid var(--line);
    border-right: 1px solid var(--line);
    background: transparent;
    color: inherit;
    font: inherit;
    text-align: center;
    padding: 6px 2px;
    -moz-appearance: textfield;
    appearance: textfield;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }
</style>
